import { useEffect, useState } from 'react';
import { Trans } from 'react-i18next';
import styles from './MaintenanceBanner.module.css';
import { getUiConfig } from '@/services/api';
import { UiConfig } from '@/services/types';

export default function MaintenanceBanner() {
  const [cfg, setCfg] = useState<UiConfig | null>(null);

  useEffect(() => {
    let mounted = true;

    getUiConfig()
      .then((data) => {
        if (mounted) setCfg(data);
      })
      .catch(() => {
        if (mounted) setCfg({ maintenance: { display: false, level: 'info', time: '', date: '' } });
      });

    return () => {
      mounted = false;
    };
  }, []);

  const m = cfg?.maintenance;
  if (!m?.display) return null;

  const cls =
    m.level === 'error' ? styles.error : m.level === 'warning' ? styles.warning : styles.info;

  return (
    <div className={`${styles.banner} ${cls}`} role="status" aria-live="polite">
      <Trans
        i18nKey="SSO_Maintenance_Banner"
        values={{ arg0: m.time, arg1: m.date }}
        components={[<br key="br" />]}
      />
    </div>
  );
}
